import { GRID_TYPE, TIME, SEASON } from "../constants";

const SquareIcons = ({ type, color }) => {
  const iconMap = {
    [GRID_TYPE.NONE]: <GridNone color={color} />,
    [GRID_TYPE.THICK]: <GridThick color={color} />,
    [GRID_TYPE.THIN]: <GridThin color={color} />,
    [GRID_TYPE.DOTTED]: <GridDotted color={color} />,
    [GRID_TYPE.HEX]: <GridHex color={color} />,
    [TIME.DAY]: <Day color={color} />,
    [TIME.NIGHT]: <Night color={color} />,
    [SEASON.SPRING]: <Spring color={color} />,
    [SEASON.FALL]: <Fall color={color} />,
    [SEASON.WINTER]: <Winter color={color} />,
  };
  return iconMap[type];
};

const GridNone = ({ color }) => (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon-none">
      <path id="None" d="M5.2353 0.5H1V4.7353" stroke={color} />
      <path id="None_2" d="M25 4.7353L25 0.5L20.7647 0.5" stroke={color} />
      <path id="None_3" d="M20.7647 24.5L25 24.5L25 20.2647" stroke={color} />
      <path id="None_4" d="M1 20.2647L1 24.5L5.2353 24.5" stroke={color} />
    </g>
  </svg>
);

const GridThin = ({ color }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon-thin">
      <rect id="Thin" x="0.5" y="0.5" width="24" height="24" stroke={color} />
    </g>
  </svg>
);

const GridThick = ({ color }) => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon-thick">
      <rect
        id="Thick"
        x="1.5"
        y="1.5"
        width="24"
        height="24"
        stroke={color}
        strokeWidth="3"
      />
    </g>
  </svg>
);

const GridDotted = ({ color }) => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon-dotted">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62452 26.8333H11.4035V24.0544H8.62452V26.8333ZM0.666626 25.1632C0.666626 26.0895 1.41049 26.8333 2.3368 26.8333H3.44557V24.0544H0.666626V25.1632ZM16.5965 26.8333H19.3754V24.0544H16.5965V26.8333ZM24.5543 26.8333H25.6631C26.5894 26.8333 27.3333 26.0895 27.3333 25.1632V24.0544H24.5543V26.8333ZM8.62452 2.94561H11.4035V0.166667H8.62452V2.94561ZM0.666626 1.83684V2.94561H3.44557V0.166667H2.3368C1.41049 0.166667 0.666626 0.910527 0.666626 1.83684ZM16.5965 2.94561H19.3754V0.166667H16.5965V2.94561ZM25.6631 0.166667H24.5543V2.94561H27.3333V1.83684C27.3333 0.910527 26.5894 0.166667 25.6631 0.166667ZM24.5543 10.9035H27.3333V8.12456H24.5543V10.9035ZM24.5543 18.8614H27.3333V16.0825H24.5543V18.8614ZM0.666626 10.9035H3.44557V8.12456H0.666626V10.9035ZM0.666626 18.8614H3.44557V16.0825H0.666626V18.8614Z"
        fill={color}
      />
    </g>
  </svg>
);

const GridHex = ({ color }) => (
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon-hex">
      <path
        id="Hex1"
        d="M12 1.5L1.6077 7.5V19.5L12 25.5L22.3923 19.5V7.5L12 1.5Z"
        stroke={color}
      />
    </g>
  </svg>
);

const Day = ({ color }) => (
  <svg
    width="37"
    height="45"
    viewBox="0 0 37 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame">
      <g id="Layer 17">
        <path
          id="Vector"
          d="M30.7036 28.8556H6.29631C6.04542 28.8556 5.84204 29.0745 5.84204 29.3445C5.84204 29.6145 6.04542 29.8334 6.29631 29.8334H30.7036C30.9544 29.8334 31.1578 29.6145 31.1578 29.3445C31.1578 29.0745 30.9544 28.8556 30.7036 28.8556Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M31.5609 32.7667H5.43911C5.12392 32.7667 4.86841 32.9856 4.86841 33.2556C4.86841 33.5256 5.12392 33.7445 5.43911 33.7445H31.5609C31.8761 33.7445 32.1316 33.5256 32.1316 33.2556C32.1316 32.9856 31.8761 32.7667 31.5609 32.7667Z"
          fill={color}
        />
        <path
          id="Vector_3"
          d="M26.9329 26.1007C24.2385 26.1395 20.1561 26.062 9.41345 26.1007C9.41345 21.241 13.3326 17.3119 18.1732 17.3119C23.0138 17.3119 26.9329 21.254 26.9329 26.1007Z"
          fill={color}
        />
      </g>
      <g id="Layer 18 copy">
        <g id="Layer 18 copy_2">
          <path
            id="Vector_4"
            d="M26.1529 19.8694L29.4288 14.7591C29.5505 14.5674 29.3292 14.353 29.1521 14.4771L24.2715 17.9403L26.164 19.8694H26.1529Z"
            fill={color}
          />
          <path
            id="Vector_5"
            d="M33.2469 25.5436L28.5322 24.5622V25.9271L33.2026 25.9497C33.4461 25.9497 33.4793 25.6 33.2469 25.5436Z"
            fill={color}
          />
          <path
            id="Vector_6"
            d="M12.1639 17.7711L7.12829 14.4658C6.94015 14.3417 6.72987 14.5673 6.85161 14.7591L10.2714 19.7001L12.1639 17.7711Z"
            fill={color}
          />
          <path
            id="Vector_7"
            d="M19.5789 16.4061L18.3505 10.4385C18.3062 10.2242 17.9963 10.2242 17.9631 10.4385L16.9117 16.4061H19.5789Z"
            fill={color}
          />
          <path
            id="Vector_8"
            d="M21.2501 16.6205L22.9434 17.4214L23.0319 15.5262C23.043 15.2781 22.7553 15.154 22.5893 15.3232L21.2501 16.6318V16.6205Z"
            fill={color}
          />
          <path
            id="Vector_9"
            d="M13.4034 17.2973L15.1521 16.643L13.8904 15.2329C13.7244 15.0524 13.4366 15.1652 13.4366 15.4134L13.4034 17.2973Z"
            fill={color}
          />
          <path
            id="Vector_10"
            d="M7.84767 24.3366L3.03343 25.2504C2.78995 25.2955 2.82316 25.6565 3.06663 25.6565L7.84767 25.7016V24.3366Z"
            fill={color}
          />
          <path
            id="Vector_11"
            d="M8.32351 22.7685L9.10928 21.0425L7.24999 20.9523C7.00651 20.941 6.88477 21.2343 7.05078 21.4035L8.33458 22.7685H8.32351Z"
            fill={color}
          />
          <path
            id="Vector_12"
            d="M27.2708 21.1328L27.9127 22.9152L29.2961 21.6292C29.4731 21.4599 29.3625 21.1666 29.119 21.1666L27.2708 21.1328Z"
            fill={color}
          />
        </g>
      </g>
    </g>
  </svg>
);

const Night = ({ color }) => (
  <svg
    width="23"
    height="25"
    viewBox="0 0 23 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_20" clipPath="url(#clip0_2324_3723)">
      <path
        id="Vector"
        d="M22.6061 18.1927C22.8476 18.081 23.1017 18.3789 22.9619 18.6024C21.8818 20.4027 20.2807 21.9547 18.2603 23.0473C12.847 25.9402 5.947 24.4131 2.33816 19.5212C-1.85521 13.8099 -0.215981 5.92576 5.78181 2.23823C7.31938 1.29462 8.99673 0.723486 10.6995 0.499999C10.9918 0.462752 11.1569 0.810398 10.9409 0.996637C8.64092 2.89627 7.20501 5.73952 7.20501 8.89317C7.20501 14.6293 11.9575 19.2853 17.8282 19.2853C20.5476 19.2853 21.5514 18.7018 22.6188 18.1803L22.6061 18.1927Z"
        fill={color}
      />
      <path
        id="Vector_2"
        d="M19.3657 10.2217L19.9121 11.3019C19.9121 11.3019 19.9757 11.3764 20.0265 11.3888L21.2464 11.5626C21.3735 11.575 21.4243 11.7364 21.3353 11.8233L20.4586 12.6676C20.4586 12.6676 20.4077 12.7545 20.4077 12.8042L20.611 13.9961C20.6365 14.1203 20.4967 14.2196 20.3823 14.1575L19.2895 13.5988C19.2895 13.5988 19.1878 13.574 19.137 13.5988L18.0442 14.1575C17.9298 14.2196 17.79 14.1203 17.8155 13.9961L18.0188 12.8042C18.0188 12.8042 18.0188 12.7049 17.9679 12.6676L17.0911 11.8233C17.0022 11.7364 17.053 11.575 17.1801 11.5626L18.4 11.3888C18.4 11.3888 18.5016 11.3515 18.5144 11.3019L19.0608 10.2217C19.1243 10.1099 19.2895 10.1099 19.3403 10.2217H19.3657Z"
        fill={color}
      />
      <path
        id="Vector_3"
        d="M20.4078 5.05665L20.8398 5.90094C20.8398 5.90094 20.8906 5.96302 20.9288 5.96302L21.8818 6.09959C21.9834 6.11201 22.0216 6.23617 21.9453 6.31066L21.2464 6.96871C21.2464 6.96871 21.2083 7.0432 21.2083 7.08045L21.3735 8.01165C21.3862 8.11097 21.2846 8.18547 21.1956 8.13581L20.3442 7.70125C20.3442 7.70125 20.268 7.67642 20.2299 7.70125L19.3785 8.13581C19.2895 8.18547 19.1752 8.11097 19.2006 8.01165L19.3658 7.08045C19.3658 7.08045 19.3658 7.00596 19.3276 6.96871L18.6288 6.31066C18.5525 6.23617 18.5906 6.11201 18.6923 6.09959L19.6453 5.96302C19.6453 5.96302 19.7216 5.93819 19.7343 5.90094L20.1663 5.05665C20.2171 4.96974 20.3442 4.96974 20.395 5.05665H20.4078Z"
        fill={color}
      />
      <path
        id="Vector_4"
        d="M12.9867 5.62778L13.6983 7.0432C13.6983 7.0432 13.7872 7.14252 13.8508 7.15494L15.4392 7.37843C15.6044 7.40326 15.6806 7.60191 15.5535 7.72607L14.3972 8.81867C14.3972 8.81867 14.3209 8.93042 14.3337 8.9925L14.6005 10.5445C14.6259 10.7059 14.448 10.8425 14.2955 10.7556L12.8723 10.023C12.8723 10.023 12.7453 9.98577 12.6817 10.023L11.2585 10.7556C11.106 10.8301 10.9281 10.7059 10.9535 10.5445L11.2204 8.9925C11.2204 8.93042 11.2204 8.85592 11.1569 8.81867L10.0005 7.72607C9.87344 7.61433 9.94968 7.40326 10.1149 7.37843L11.7033 7.15494C11.7668 7.15494 11.8303 7.10528 11.8558 7.0432L12.5674 5.62778C12.6436 5.47879 12.8596 5.47879 12.9359 5.62778H12.9867Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2324_3723">
        <rect
          width="23"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Spring = ({ color }) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame">
      <g id="Layer 8 copy 3">
        <g id="Layer 8 copy 3_2">
          <g id="Group">
            <path
              id="Vector"
              d="M27.713 14.1105L26.2827 19.3215C26.2281 19.5128 26.3738 19.695 26.5651 19.695H29.4348C29.6261 19.695 29.7719 19.5128 29.7172 19.3215L28.287 14.1105C28.205 13.819 27.795 13.819 27.713 14.1105Z"
              fill={color}
            />
            <path
              id="Vector_2"
              d="M23.1853 22.0181L24.5883 21.2711C24.7705 21.18 24.7978 20.934 24.652 20.7974L22.83 19.0756C22.6205 18.8842 22.2834 19.0573 22.3381 19.3398L22.7662 21.8177C22.8027 22.0181 23.0213 22.1275 23.1944 22.0272L23.1853 22.0181Z"
              fill={color}
            />
          </g>
          <g id="Group_2">
            <path
              id="Vector_3"
              d="M40.3214 21.0616L35.0922 22.4281C34.9008 22.4736 34.8097 22.6923 34.91 22.8654L36.3402 25.3524C36.4405 25.5255 36.6682 25.5529 36.8049 25.4162L40.6038 21.5717C40.8133 21.3622 40.6038 21.0069 40.3214 21.0798V21.0616Z"
              fill={color}
            />
            <path
              id="Vector_4"
              d="M31.2022 21.0889L32.5505 21.927C32.7236 22.0363 32.9513 21.9361 32.9969 21.7448L33.5799 19.3033C33.6437 19.03 33.3248 18.8296 33.1062 19.0118L31.1748 20.6152C31.02 20.7427 31.0382 20.9887 31.2113 21.098L31.2022 21.0889Z"
              fill={color}
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_5"
              d="M40.6039 35.4465L36.8049 31.602C36.6683 31.4653 36.4405 31.4927 36.3403 31.6658L34.91 34.1528C34.8098 34.3259 34.91 34.5354 35.0922 34.5901L40.3215 35.9566C40.613 36.0295 40.8134 35.6742 40.6039 35.4647V35.4465Z"
              fill={color}
            />
            <path
              id="Vector_6"
              d="M36.0215 27.5662L35.976 29.1514C35.976 29.3518 36.1673 29.4976 36.3586 29.4429L38.7637 28.7232C39.037 28.6412 39.0461 28.2586 38.7819 28.1584L36.4223 27.2929C36.231 27.22 36.0306 27.3567 36.0215 27.5571V27.5662Z"
              fill={color}
            />
          </g>
          <g id="Group_4">
            <path
              id="Vector_7"
              d="M28.287 42.8895L29.7172 37.6785C29.7719 37.4872 29.6261 37.305 29.4348 37.305H26.5651C26.3738 37.305 26.2281 37.4872 26.2827 37.6785L27.713 42.8895C27.795 43.181 28.205 43.181 28.287 42.8895Z"
              fill={color}
            />
            <path
              id="Vector_8"
              d="M32.8147 34.9819L31.4118 35.7289C31.2296 35.82 31.2022 36.066 31.348 36.2026L33.17 37.9244C33.3795 38.1158 33.7166 37.9427 33.662 37.6602L33.2338 35.1823C33.1973 34.9819 32.9787 34.8725 32.8056 34.9728L32.8147 34.9819Z"
              fill={color}
            />
          </g>
          <g id="Group_5">
            <path
              id="Vector_9"
              d="M15.6785 35.9475L20.9077 34.581C21.099 34.5354 21.1901 34.3168 21.0899 34.1437L19.6596 31.6566C19.5594 31.4836 19.3317 31.4562 19.195 31.5929L15.3961 35.4374C15.1866 35.6469 15.3961 36.0022 15.6785 35.9293V35.9475Z"
              fill={color}
            />
            <path
              id="Vector_10"
              d="M24.7978 35.9111L23.4495 35.073C23.2764 34.9636 23.0486 35.0638 23.0031 35.2552L22.42 37.6967C22.3562 37.97 22.6751 38.1704 22.8937 37.9882L24.8251 36.3848C24.98 36.2573 24.9617 36.0113 24.7887 35.902L24.7978 35.9111Z"
              fill={color}
            />
          </g>
          <g id="Group_6">
            <path
              id="Vector_11"
              d="M15.3961 21.5535L19.195 25.398C19.3317 25.5346 19.5594 25.5073 19.6596 25.3342L21.0899 22.8472C21.1901 22.6741 21.0899 22.4645 20.9077 22.4099L15.6785 21.0434C15.387 20.9705 15.1866 21.3258 15.3961 21.5353V21.5535Z"
              fill={color}
            />
            <path
              id="Vector_12"
              d="M19.9785 29.4338L20.024 27.8486C20.024 27.6482 19.8327 27.5024 19.6414 27.5571L17.2363 28.2768C16.963 28.3588 16.9539 28.7414 17.2181 28.8416L19.5776 29.7071C19.7689 29.78 19.9694 29.6433 19.9785 29.4429V29.4338Z"
              fill={color}
            />
          </g>
          <g id="Group_7">
            <path
              id="Vector_13"
              d="M27.713 14.1105L26.2827 19.3215C26.2281 19.5128 26.3738 19.695 26.5651 19.695H29.4348C29.6261 19.695 29.7719 19.5128 29.7172 19.3215L28.287 14.1105C28.205 13.819 27.795 13.819 27.713 14.1105Z"
              fill={color}
            />
            <path
              id="Vector_14"
              d="M23.1853 22.0181L24.5883 21.2711C24.7705 21.18 24.7978 20.934 24.652 20.7974L22.83 19.0756C22.6205 18.8842 22.2834 19.0573 22.3381 19.3398L22.7662 21.8177C22.8027 22.0181 23.0213 22.1275 23.1944 22.0272L23.1853 22.0181Z"
              fill={color}
            />
          </g>
        </g>
      </g>
      <g id="Layer 13 copy">
        <path
          id="Vector_15"
          d="M28.0046 35.2916C31.753 35.2916 34.7916 32.2529 34.7916 28.5045C34.7916 24.7562 31.753 21.7175 28.0046 21.7175C24.2562 21.7175 21.2175 24.7562 21.2175 28.5045C21.2175 32.2529 24.2562 35.2916 28.0046 35.2916Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

const Fall = ({ color }) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_15">
      <path
        id="Vector"
        d="M36.2483 32.3287L29.5799 32.198C29.0809 32.1887 28.7906 32.7767 29.09 33.1875L29.589 33.8782C29.9156 34.3263 29.5346 34.961 28.9993 34.8584L27.8017 34.2236L26.7674 33.6915L26.6676 32.0206C26.6586 31.8059 26.7493 31.5912 26.9307 31.4699L31.4035 28.3148C31.4035 28.3148 31.8027 27.9694 31.5396 27.6054C31.2765 27.2413 30.7322 27.624 30.7322 27.624L26.958 29.7243C26.8037 29.8083 26.6223 29.6963 26.6223 29.519L26.5497 21.0058C26.5497 21.0058 26.5225 20.5391 26.1233 20.5391C25.7241 20.5391 25.7241 21.0338 25.7241 21.0338L25.3884 29.3883C25.3793 29.631 25.1253 29.7897 24.9075 29.6777L20.4166 27.3813C20.4166 27.3813 20.0174 27.092 19.7906 27.484C19.5638 27.8761 19.9721 28.0721 19.9721 28.0721L25.0164 31.5446C25.1979 31.6659 25.2886 31.8806 25.2705 32.0953L25.1525 33.3368C25.1253 33.5889 24.9801 33.8129 24.7624 33.9249L24.1727 34.2236L22.9751 34.8584C22.4398 34.961 22.0497 34.3356 22.3854 33.8782L22.8844 33.1875C23.1838 32.7767 22.8844 32.1887 22.3944 32.198L15.7261 32.3287C15.1908 32.338 14.9096 31.6753 15.2815 31.2832L16.5063 29.995C16.7331 29.7523 16.7331 29.3696 16.5063 29.1362L12.8682 25.281C12.4418 24.8237 12.8682 24.0862 13.467 24.2542L15.6444 24.8983C16.0981 25.029 16.5154 24.5996 16.3884 24.1329L16.0164 22.8354C15.8531 22.2753 16.4791 21.8179 16.9418 22.1633L21.9136 25.8225L22.0769 24.9263C22.1041 24.7863 22.0769 24.637 22.0134 24.5156L18.3662 17.8414C18.094 17.3373 18.5749 16.7585 19.1011 16.9639L23.0477 18.4761C23.3652 18.5975 23.719 18.4294 23.8279 18.0934C24.1727 17.0106 24.9166 14.7049 25.4428 13.1087C25.6243 12.558 26.3773 12.558 26.5588 13.1087C27.085 14.7049 27.8289 17.0106 28.1737 18.0934C28.2826 18.4294 28.6364 18.5975 28.9539 18.4761L32.9005 16.9639C33.4267 16.7585 33.9076 17.3466 33.6354 17.8414L29.9882 24.5156C29.9156 24.637 29.8975 24.7863 29.9247 24.9263L30.088 25.8225L35.0598 22.1633C35.5225 21.8179 36.1485 22.2753 35.9852 22.8354L35.6132 24.1329C35.4771 24.5996 35.9035 25.0383 36.3572 24.8983L38.5346 24.2542C39.1243 24.0769 39.5598 24.8237 39.1334 25.281L35.4953 29.1362C35.2685 29.3789 35.2685 29.7617 35.4953 29.995L36.7201 31.2832C37.092 31.6753 36.8199 32.3474 36.2755 32.3287H36.2483Z"
        fill={color}
      />
      <path
        id="Vector_2"
        d="M25.9862 40.0709V34.179C25.9862 34.179 26.1368 33.7609 25.4457 33.7609C24.7546 33.7609 24.9052 34.179 24.9052 34.179V40.0709C24.9052 40.0709 24.8964 40.413 25.4457 40.413C25.995 40.413 25.9862 40.0709 25.9862 40.0709Z"
        fill={color}
      />
    </g>
  </svg>
);

const Winter = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="34"
    viewBox="0 0 35 34"
    fill="none"
  >
    <path
      d="M12.4699 20.2075L10.8088 20.9887L11.0026 12.8192L12.6268 13.7792L12.4699 20.2075Z"
      fill={color}
    />
    <path
      d="M9.0278 17.2522L5.59497 18.1181C5.54883 18.1275 5.50269 18.1181 5.45655 18.1087L3.50943 17.2334C3.3341 17.1581 3.3341 16.904 3.50943 16.8193L5.44732 15.9534C5.44732 15.9534 5.5396 15.9251 5.58574 15.944L9.01857 16.8193C9.24004 16.8757 9.24004 17.1957 9.01857 17.2522H9.0278Z"
      fill={color}
    />
    <path
      d="M9.79386 9.02623L10.1722 11.3227C10.1907 11.4357 10.2645 11.5392 10.366 11.6051L14.7032 14.1557C14.8877 14.2686 14.9523 14.5133 14.8508 14.7016L14.3248 15.6333C14.2141 15.8216 13.9742 15.8875 13.7896 15.7839L9.48011 13.2427C9.3786 13.1769 9.24941 13.1769 9.13867 13.2239L6.90549 14.1651C6.70247 14.2498 6.481 14.1557 6.39794 13.9486L6.06573 13.1298C5.98268 12.9227 6.07496 12.6968 6.27798 12.6121L7.51454 12.0851L5.79812 11.078C5.61356 10.9651 5.54896 10.7204 5.65047 10.5321L6.17647 9.60035C6.28721 9.41212 6.52714 9.34623 6.7117 9.44976L8.36352 10.4192L8.17896 9.30859C8.14204 9.09211 8.28969 8.88505 8.50194 8.84741L9.35092 8.69682C9.56316 8.65917 9.76618 8.80976 9.80309 9.02623H9.79386Z"
      fill={color}
    />
    <path
      d="M17.7112 23.0404L17.5451 24.904L10.7072 20.6404L12.3221 19.6898L17.7112 23.0404Z"
      fill={color}
    />
    <path
      d="M13.4757 24.6122L12.4975 28.0758C12.4883 28.1228 12.4514 28.1605 12.4144 28.1981L10.7073 29.4781C10.5504 29.5911 10.3381 29.4687 10.3566 29.2711L10.5873 27.1252C10.5873 27.0781 10.615 27.031 10.6519 26.9934L13.1066 24.3957C13.2634 24.2263 13.5403 24.3957 13.4757 24.6122Z"
      fill={color}
    />
    <path
      d="M6.87767 19.8122L9.00935 20.6216C9.12008 20.6593 9.24005 20.6498 9.34156 20.5934L13.6787 18.0428C13.8633 17.9298 14.1032 17.9957 14.214 18.1934L14.74 19.1251C14.8507 19.3134 14.7861 19.5581 14.5923 19.671L10.2828 22.2122C10.1813 22.2781 10.1075 22.3816 10.089 22.504L9.77527 24.9416C9.74759 25.1581 9.5538 25.3181 9.33233 25.2805L8.47412 25.1675C8.26187 25.1393 8.105 24.9416 8.14191 24.7158L8.31724 23.3605L6.60083 24.3675C6.41627 24.4805 6.17634 24.4146 6.0656 24.2169L5.5396 23.2852C5.42887 23.0969 5.49346 22.8522 5.68725 22.7393L7.33907 21.7699L6.30553 21.3746C6.10251 21.2993 6.001 21.0734 6.07483 20.8663L6.37013 20.0381C6.44395 19.831 6.67465 19.7275 6.87767 19.8028V19.8122Z"
      fill={color}
    />
    <path
      d="M22.7409 19.8311L24.2358 20.904L17.1948 24.8193V22.9087L22.7409 19.8311Z"
      fill={color}
    />
    <path
      d="M21.9472 24.3582L24.3927 26.9558C24.3927 26.9558 24.448 27.0405 24.448 27.0876L24.6787 29.2335C24.6972 29.4311 24.4849 29.5535 24.3281 29.4405L22.6209 28.1605C22.6209 28.1605 22.5563 28.0852 22.5378 28.0382L21.5596 24.5746C21.4951 24.3487 21.7719 24.1887 21.9288 24.3582H21.9472Z"
      fill={color}
    />
    <path
      d="M14.5741 27.7841L16.3367 26.3064C16.4289 26.2311 16.4751 26.1182 16.4751 25.9958V20.8852C16.4751 20.6687 16.6504 20.4899 16.8627 20.4899H17.9239C18.1361 20.4899 18.3115 20.6687 18.3115 20.8852V25.9582C18.3115 26.0805 18.3668 26.2029 18.4683 26.2782L20.3785 27.7747C20.5539 27.9064 20.5816 28.1606 20.4524 28.33L19.9264 29.0264C19.7972 29.2053 19.548 29.2335 19.3819 29.1017L18.3207 28.2735V30.2876C18.3207 30.5041 18.1454 30.6829 17.9331 30.6829H16.8719C16.6596 30.6829 16.4843 30.5041 16.4843 30.2876V28.3488L15.6353 29.0641C15.4692 29.2053 15.2201 29.177 15.0816 29.0076L14.528 28.33C14.3895 28.1606 14.4172 27.9064 14.5833 27.7653L14.5741 27.7841Z"
      fill={color}
    />
    <path
      d="M22.5192 13.7793L24.1895 13.0075L23.9865 21.177L22.3716 20.217L22.5192 13.7793Z"
      fill={color}
    />
    <path
      d="M25.9705 16.744L29.4034 15.8781C29.4495 15.8687 29.4957 15.8781 29.5418 15.8875L31.4797 16.7534C31.655 16.8287 31.655 17.0828 31.4797 17.1675L29.5418 18.0334C29.5418 18.0334 29.4495 18.0616 29.4034 18.0428L25.9705 17.1675C25.7491 17.111 25.7491 16.791 25.9705 16.7346V16.744Z"
      fill={color}
    />
    <path
      d="M25.1955 24.97L24.8171 22.6735C24.7987 22.5605 24.7248 22.457 24.6233 22.3911L20.2862 19.8405C20.1016 19.7276 20.037 19.4829 20.1385 19.2946L20.6645 18.3629C20.7752 18.1746 21.0152 18.1087 21.1997 18.2123L25.5092 20.7535C25.6107 20.8193 25.7399 20.8193 25.8507 20.7723L28.0839 19.8311C28.2869 19.7464 28.5083 19.8405 28.5914 20.0476L28.9236 20.8664C29.0067 21.0735 28.9144 21.2993 28.7114 21.3841L27.4748 21.9111L29.1912 22.9182C29.3758 23.0311 29.4404 23.2758 29.3389 23.4641L28.8129 24.3958C28.7021 24.5841 28.4622 24.65 28.2776 24.5464L26.6258 23.577L26.8104 24.6876C26.8473 24.9041 26.6996 25.1111 26.4874 25.1488L25.6384 25.2994C25.4262 25.337 25.2232 25.1864 25.1862 24.97H25.1955Z"
      fill={color}
    />
    <path
      d="M17.2777 10.9556L17.453 9.09209L24.291 13.3462L22.6669 14.3062L17.2777 10.9556Z"
      fill={color}
    />
    <path
      d="M21.5227 9.38387L22.5008 5.92031C22.5101 5.87325 22.547 5.8356 22.5839 5.79795L24.2911 4.51794C24.448 4.405 24.6602 4.52736 24.6417 4.725L24.411 6.8709C24.411 6.91796 24.3834 6.96502 24.3464 7.00267L21.8918 9.60034C21.7349 9.76975 21.4581 9.60034 21.5227 9.38387Z"
      fill={color}
    />
    <path
      d="M28.1206 14.1839L25.989 13.3745C25.8782 13.3369 25.7583 13.3463 25.6568 13.4027L21.3196 15.9533C21.135 16.0663 20.8951 16.0004 20.7844 15.8028L20.2584 14.871C20.1476 14.6827 20.2122 14.438 20.406 14.3251L24.7155 11.7839C24.817 11.718 24.8908 11.6145 24.9093 11.4921L25.223 9.05446C25.2507 8.83799 25.4445 8.67799 25.666 8.71564L26.5242 8.82858C26.7364 8.85681 26.8933 9.05446 26.8564 9.28035L26.6811 10.6357L28.3975 9.62858C28.582 9.51564 28.822 9.58152 28.9327 9.77917L29.4587 10.7109C29.5694 10.8992 29.5049 11.1439 29.3111 11.2568L27.6592 12.2263L28.6928 12.6216C28.8958 12.6968 28.9973 12.9227 28.9235 13.1298L28.6282 13.958C28.5544 14.1651 28.3237 14.2686 28.1206 14.1933V14.1839Z"
      fill={color}
    />
    <path
      d="M12.2576 14.1651L10.7627 13.0827L17.7945 9.17683V11.0874L12.2576 14.1651Z"
      fill={color}
    />
    <path
      d="M13.0512 9.63803L10.6058 7.04036C10.6058 7.04036 10.5504 6.95565 10.5504 6.90859L10.3197 4.76269C10.3013 4.56504 10.5135 4.44269 10.6704 4.55563L12.3776 5.83564C12.3776 5.83564 12.4422 5.91094 12.4606 5.958L13.4388 9.42156C13.5034 9.64744 13.2266 9.80744 13.0697 9.63803H13.0512Z"
      fill={color}
    />
    <path
      d="M20.4153 6.21211L18.6527 7.68976C18.5604 7.76506 18.5143 7.878 18.5143 8.00036V13.111C18.5143 13.3275 18.3389 13.5063 18.1267 13.5063H17.0655C16.8532 13.5063 16.6779 13.3275 16.6779 13.111V8.02859C16.6779 7.90624 16.6225 7.78388 16.521 7.70859L14.6108 6.21211C14.4355 6.08034 14.4078 5.82622 14.537 5.65681L15.063 4.96033C15.1922 4.7815 15.4413 4.75327 15.6074 4.88504L16.6687 5.71328V3.68973C16.6687 3.47326 16.844 3.29443 17.0563 3.29443H18.1175C18.3297 3.29443 18.5051 3.47326 18.5051 3.68973V5.63798L19.354 4.92268C19.5201 4.7815 19.7693 4.80974 19.9077 4.97915L20.4614 5.65681C20.5998 5.82622 20.5721 6.08034 20.406 6.22152L20.4153 6.21211Z"
      fill={color}
    />
    <path
      d="M17.499 19.6899C18.9566 19.6899 20.1382 18.4847 20.1382 16.9981C20.1382 15.5115 18.9566 14.3063 17.499 14.3063C16.0414 14.3063 14.8597 15.5115 14.8597 16.9981C14.8597 18.4847 16.0414 19.6899 17.499 19.6899Z"
      stroke={color}
      strokeWidth="2.5"
    />
  </svg>
);

export default SquareIcons;
